document.addEventListener("DOMContentLoaded", function () {
  console.log("run =========> 250th anniversary generic ");
  const currentUrl = new URL(window.location.href);
  const isVariantSpecifiedInUrl = currentUrl.searchParams.has("variant");
  const variantsDD = document.querySelector(".variantsDD");
  const atcButton = document.querySelector("#purchaseAddToCart");
  const options = document.querySelectorAll(
    ".c-pp-anniversary__card .c-pp-anniversary__option"
  );
  const card = document.querySelector(".c-pp-anniversary__card");
  const optionValues = Array.from(options).map(
    (option) => option.dataset.design
  );
  const errorText = document.querySelector(".c-pp-anniversary__error-text");
  const applyButton = document.querySelector(".c-pp-anniversary__button");

  const resetButton = document.querySelector("#resetDD");
  const parentPurchaseButton = document.querySelector(".parentPurchase");
  const selectionDisplay = document.querySelector(
    ".c-pp-anniversary__selection-display"
  );
  const selectionResetButton = document.querySelector(
    ".c-pp-anniversary__selection-display-reset"
  );

  const dropdownOptions = document.querySelector("#hp-custom-v1-dd .options");

  dropdownOptions.addEventListener("click", function (e) {
    const target = e.target;
    const dataEngine = target.dataset.engine;
    const dataPcCode = target.dataset.pcCode;
    if (!dataEngine) return;
    if (dataPcCode) return; // If data-pc-code is present, it is model list item, not engine list item
    handleLastOptionClick(target);
  });

  function handleLastOptionClick() {
    resetButton.style.display = "none";
    parentPurchaseButton.style.display = "none";
    showCard();
  }

  const anniversary_option = Array.from(options).find(
    (option) => option.dataset.design && option.dataset.design.includes("250")
  );
  const anniversaryInfo = anniversary_option.querySelector(
    ".c-pp-anniversary__option .c-pp-anniversary__info"
  );
  const anniversaryImgContainer = anniversary_option.querySelector(
    ".c-pp-anniversary__option .c-pp-anniversary__image-container"
  );

  const bottomButton = document.querySelector("#xdBannerDropdownOpenId");
  const bottomAtcButton = document.querySelector(
    ".fixed-banner-btn .atcBtnDrawer"
  );

  let fireworksDone = false;
  let timerIntervalId;
  let fireworksCanvas = null;
  let fireworksFrameId = null;
  let startTime = null;
  let lastTimestamp = null;
  const isMobile = window.innerWidth < 768;

  function scrollToVariantsDD(val) {
    if (isMobile) {
      const yOffset = -val;
      const y =
        variantsDD.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  }

  if (isVariantSpecifiedInUrl) {
    showCard();
  }

  function showCard() {
    card.style.display = "block";
    scrollToVariantsDD(30);
    bottomButton.style.display = "block";
    bottomButton.innerHTML = "SELECT YOUR DESIGN";
    // bottomAtcButton.style.display = "none"
  }
  function hideCard() {
    card.style.display = "none";
    // bottomAtcButton.style.display = "none"
  }
  function showSelectionDisplay() {
    selectionDisplay.classList.remove("hidden");
  }
  function hideSelectionDisplay() {
    selectionDisplay.classList.add("hidden");
  }

  selectionResetButton.addEventListener("click", function () {
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (selectedOption) {
      selectedOption.classList.remove("c-pp-anniversary__option--selected");
    }
    hideSelectionDisplay();
    showCard();
    errorText.classList.add("hidden");
    selectionDisplay
      .querySelectorAll(".c-pp-anniversary__option")
      .forEach((item) => {
        item.classList.add("hidden");
      });
    bottomButton.classList.remove("handleApply");
    resetButton.style.display = "none";
    parentPurchaseButton.style.display = "none";
  });

  resetButton.addEventListener("click", function () {
    hideCard();
    hideSelectionDisplay();
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (selectedOption) {
      selectedOption.classList.remove("c-pp-anniversary__option--selected");
    }
    errorText.classList.add("hidden");
    selectionDisplay
      .querySelectorAll(".c-pp-anniversary__option")
      .forEach((item) => {
        item.classList.add("hidden");
      });
    bottomButton.classList.remove("handleApply");
  });

  function showErrorText() {
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (!selectedOption) {
      errorText.classList.remove("hidden");
    }
  }

  applyButton.addEventListener("click", function () {
    stopFireworks();
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    const selectedOptionValue = selectedOption
      ? selectedOption.dataset.design
      : null;
    const selectedOptionDisplayItem = selectionDisplay.querySelector(
      `[data-design='${selectedOptionValue}']`
    );

    if (!selectedOption) {
      showErrorText();
      return;
    }

    showSelectionDisplay();
    selectedOptionDisplayItem.classList.remove("hidden");
    updateATCButtonDataset();
    hideCard();
    // showVisibleAfterSelection()
    scrollToVariantsDD(100);

    resetButton.style.display = "block";
    parentPurchaseButton.style.display = "block";
    document.querySelector(".selectActions");
    applyButton.classList.remove("cta-glow-ping");
  });

  function updateATCButtonDataset() {
    const selectedOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (!selectedOption) throw new Error("No option selected");
    const selectedOptionValue = selectedOption.dataset.design;
    const selection = atcButton.dataset.selection;
    let updatedSelection = selection;
    optionValues.forEach((val) => {
      if (updatedSelection.includes(val)) {
        updatedSelection = updatedSelection.replace(" - " + val, "");
      }
    });
    const newSelection = `${updatedSelection} - ${selectedOptionValue}`;
    atcButton.dataset.selection = newSelection;
  }

  console.log("here");
  console.log("options", options);
  options.forEach((option) => {
    console.log("option", option);
    option.addEventListener("click", handleOptionClick);
  });

  function handleOptionClick(e) {
    const activeOption = document.querySelector(
      ".c-pp-anniversary__option--selected"
    );
    if (activeOption) {
      activeOption.classList.remove("c-pp-anniversary__option--selected");
    }
    e.currentTarget.classList.add("c-pp-anniversary__option--selected");

    if (e.currentTarget.dataset.design.includes("250")) {
      triggerFireworks(e.currentTarget);
    } else {
      stopFireworks();
    }

    errorText.classList.add("hidden");
    atcButton.disabled = false;
    atcButton.style.display = "block";
    applyButton.classList.add("cta-glow-ping");

    bottomButton.innerHTML = "BUY NOW";
    bottomButton.classList.add("handleApply");
  }

  if (bottomButton) {
    bottomButton.addEventListener("click", () => {
      const hasHandleApply = bottomButton.classList.contains("handleApply");
      if (hasHandleApply) {
        applyButton.click();
        atcButton.click();
      }
    });
  }

  function triggerFireworks(targetElement) {
    stopFireworks();

    const canvas = document.createElement("canvas");
    fireworksCanvas = canvas;
    canvas.className = "firework-canvas";

    const dpr = window.devicePixelRatio || 1;
    canvas.width = targetElement.offsetWidth * dpr;
    canvas.height = targetElement.offsetHeight * dpr;
    canvas.style.position = "absolute";
    canvas.style.top = 0;
    canvas.style.left = 0;
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "none";
    canvas.style.zIndex = "100";

    targetElement.style.position = "relative";
    targetElement.appendChild(canvas);

    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);

    const particles = [];

    let beamY = canvas.height / dpr;
    const beamSpeed = 6; // base speed per frame at 60fps
    let exploded = false;

    const flagImage = new Image();
    flagImage.loading = "eager";
    flagImage.src =
      "https://cdn.shopify.com/s/files/1/0050/1068/6042/files/star.svg?v=1676480837";
    const showFlag = true;

    let flagScale = 0;

    function explode(x, y) {
      const colors = ["#ff0000", "#ff0000", "#ffffff", "#0000ff"];
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      const totalParticles = isMobile ? 250 : 800;

      for (let i = 0; i < totalParticles; i++) {
        const angle = Math.random() * -Math.PI;
        const speed = Math.random() * 1.5 + 0.6;
        const size = Math.random() * 1 + 0.9;

        particles.push({
          x,
          y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          alpha: 1,
          color: colors[i % colors.length],
          gravity: 0.055,
          size: size,
          sparkle: i < 50,
        });
      }
    }

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      if (!lastTimestamp) lastTimestamp = timestamp;

      const delta = timestamp - lastTimestamp;
      lastTimestamp = timestamp;
      const elapsed = timestamp - startTime;

      ctx.fillStyle = "rgba(0, 0, 0, 0.25)";
      ctx.fillRect(0, 0, canvas.width / dpr, canvas.height / dpr);

      if (!exploded) {
        beamY -= beamSpeed * (delta / 16.67); // normalize for 60fps baseline

        const beamX = canvas.width / dpr / 2;
        const gradient = ctx.createLinearGradient(
          beamX,
          beamY,
          beamX,
          beamY + 40
        );
        gradient.addColorStop(0, "rgba(255, 255, 255, 0.9)");
        gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

        ctx.beginPath();
        ctx.fillStyle = gradient;
        ctx.fillRect(beamX - 2, beamY, 4, 40);
        ctx.closePath();

        if (beamY <= (canvas.height / dpr) * 0.35) {
          exploded = true;
          explode(canvas.width / dpr / 2, beamY);
        }
      }

      particles.forEach((p) => {
        if (p.vy < 0) {
          p.vy += p.gravity * 0.5;
        } else {
          p.vy += p.gravity;
        }

        p.x += p.vx;
        p.y += p.vy;
        p.alpha -= 0.006;

        if (p.alpha > 0) {
          ctx.beginPath();
          ctx.globalAlpha = p.alpha;

          if (p.sparkle) {
            ctx.shadowColor = p.color;
            ctx.shadowBlur = 10;
          } else {
            ctx.shadowBlur = 0;
          }

          ctx.fillStyle = p.color;
          ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
          ctx.fill();
          ctx.globalAlpha = 1;
        }
      });

      if (showFlag && exploded) {
        if (flagScale < 1) flagScale += 0.015;
        const imgWidth = 120 * flagScale;
        const imgHeight = 120 * flagScale;
        ctx.drawImage(
          flagImage,
          canvas.width / dpr / 2 - imgWidth / 2,
          beamY - imgHeight / 2,
          imgWidth,
          imgHeight
        );
      }

      let timer;
      if (isMobile) {
        timer = 2000;
      } else {
        timer = 1500;
      }

      if (exploded && elapsed >= timer) {
        stopFireworks();
      } else {
        fireworksFrameId = requestAnimationFrame(animate);
      }
    }

    fireworksFrameId = requestAnimationFrame(animate);
  }

  function stopFireworks() {
    if (fireworksFrameId) {
      cancelAnimationFrame(fireworksFrameId);
      fireworksFrameId = null;
    }
    if (fireworksCanvas) {
      fireworksCanvas.remove();
      fireworksCanvas = null;
    }
    startTime = null;
    lastTimestamp = null;
  }
});
